<template>
  <div class="page_wave_admin">
    <h1>Vlny na jídlo</h1>
    <div class="actions">
      <button @click="add" class="add" title="Přidat vlnu">
        <i class="fa fa-plus"></i>
      </button>
      <button @click="remove" class="remove" title="Odebrat poslední vlnu">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <tabloid name="waves" :columns="columns" :data="waves">
      <template v-slot:capacity="{ row }">
        <inputerNumber :paths="['waves', row.id, 'capacity']" min="0" />
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import tabloid from "../../components/tabloid";
import inputerNumber from "../../components/inputer-number";

export default {
  name: "admin_waves",
  components: {
    tabloid,
    inputerNumber,
  },
  data: () => ({
    columns: {
      id: { title: "Pořadí" },
      capacity: { title: "Kapacita" },
      usedByOther: { title: "Využito" },
    },
  }),
  computed: {
    ...mapState(["waves"]),
  },
  methods: {
    add() {
      const id = Object.keys(this.waves).length + 1;
      this.$store.commit("add", {
        paths: ["waves", id],
        value: {
          id: id,
          capacity: 1,
          usedByOther: 0
        }
      });
    },
    remove() {
      if (!confirm("Opravdu chcete odebrat poslední vlnu?")) return;

      const id = Object.keys(this.waves).length;
      this.$store.commit("remove", {
        paths: ["waves", id]
      });
    }
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_wave_admin
  @include table-view()
  grid-template-areas: "label actions" "table table"
  grid-template-columns: auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: label
  .actions
    grid-area: actions
    .add
      @include first-input()
    .remove
      @include button-danger()
      @include last-input()
  table
    grid-area: table
</style>